import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../components/stats.module.css';
import { scoreColor } from '../components/palette';
import { formatDate, formatNumber } from '../utils/format';

const FILTERS = [
  { key: 'all', label: 'Todas' },
  { key: 'promoter', label: 'Promotores' },
  { key: 'neutral', label: 'Neutros' },
  { key: 'detractor', label: 'Detratores' },
];

// Quantas respostas aparecem antes do "Ver todas"
const VISIBLE_LIMIT = 8;

/**
 * Quem respondeu a pesquisa de satisfação no período: nota, nome (com link para
 * o cadastro), data e o comentário quando houver. Filtro por categoria e
 * lista completa sob demanda, para achar quem gostou e quem não gostou.
 * `people`: [{ patientId, name, score, category, comment, date }], mais recentes primeiro.
 */
const SatisfactionResponses = ({ people }) => {
  const [filter, setFilter] = useState('all');
  const [expanded, setExpanded] = useState(false);
  const all = people || [];

  if (all.length === 0) {
    return <div className={styles.emptyChart}>Nenhuma resposta no período.</div>;
  }

  const counts = { all: all.length };
  all.forEach((item) => { counts[item.category] = (counts[item.category] || 0) + 1; });
  const list = filter === 'all' ? all : all.filter((item) => item.category === filter);
  const visible = expanded ? list : list.slice(0, VISIBLE_LIMIT);

  return (
    <div className={styles.responses}>
      <div className={styles.filters} role="group" aria-label="Filtrar por categoria">
        {FILTERS.map((item) => (
          <button
            key={item.key}
            type="button"
            className={`${styles.filterItem} ${filter === item.key ? styles.filterActive : ''}`}
            onClick={() => { setFilter(item.key); setExpanded(false); }}
          >
            {item.label}
            <span className={styles.filterCount}>{formatNumber(counts[item.key] || 0)}</span>
          </button>
        ))}
      </div>

      {list.length === 0 ? (
        <div className={styles.emptyChart}>Nenhuma resposta nessa categoria no período.</div>
      ) : (
        <div className={styles.comments}>
          {visible.map((item, index) => (
            <div key={`${item.patientId}-${item.date}-${index}`} className={styles.comment}>
              <span className={styles.score} style={{ background: scoreColor(item.score) }}>{item.score}</span>
              <div className={styles.commentBody}>
                <span className={styles.responseName}>
                  <Link to={`/patients/${item.patientId}`}>{item.name}</Link>
                  <span className={styles.commentMeta}>{' · '}{formatDate(item.date)}</span>
                </span>
                {item.comment && <span className={styles.responseComment}>{item.comment}</span>}
              </div>
            </div>
          ))}
        </div>
      )}

      {list.length > VISIBLE_LIMIT && (
        <button type="button" className={styles.more} onClick={() => setExpanded((current) => !current)}>
          {expanded ? 'Ver menos' : `Ver todas as ${formatNumber(list.length)} respostas`}
        </button>
      )}
    </div>
  );
};

export default SatisfactionResponses;
